var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManageMembersGear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "100%",
    x2: "23.869%",
    y1: "-36.708%",
    y2: "114.128%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#50E3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#268AFF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C7CFE2",
    fillRule: "nonzero",
    d: "M79.582 34.272a1.38 1.38 0 0 0-1.37-1.169h-3.02a35.667 35.667 0 0 0-5.428-13.113l2.13-2.13c.482-.482.55-1.252.141-1.798a40.213 40.213 0 0 0-8.097-8.097 1.382 1.382 0 0 0-1.798.141l-2.13 2.13a35.658 35.658 0 0 0-13.113-5.429V1.79a1.38 1.38 0 0 0-1.169-1.37A39.871 39.871 0 0 0 40 0c-1.946 0-3.857.147-5.728.418a1.38 1.38 0 0 0-1.169 1.37v3.02a35.662 35.662 0 0 0-13.113 5.428l-2.13-2.13a1.382 1.382 0 0 0-1.798-.142 40.22 40.22 0 0 0-8.097 8.097 1.382 1.382 0 0 0 .142 1.799l2.13 2.13a35.659 35.659 0 0 0-5.43 13.113H1.79a1.38 1.38 0 0 0-1.37 1.169A39.894 39.894 0 0 0 0 40c0 1.946.147 3.857.418 5.728a1.38 1.38 0 0 0 1.37 1.169h3.02a35.662 35.662 0 0 0 5.428 13.113l-2.13 2.13a1.382 1.382 0 0 0-.142 1.798 40.212 40.212 0 0 0 8.097 8.097c.546.409 1.316.34 1.799-.142l2.13-2.13a35.66 35.66 0 0 0 13.113 5.43v3.018a1.38 1.38 0 0 0 1.168 1.37c1.872.272 3.783.419 5.729.419a39.89 39.89 0 0 0 5.728-.418 1.38 1.38 0 0 0 1.169-1.37v-3.02a35.662 35.662 0 0 0 13.113-5.428l2.13 2.13c.482.482 1.252.55 1.798.141a40.208 40.208 0 0 0 8.097-8.096 1.382 1.382 0 0 0-.141-1.799l-2.13-2.13a35.66 35.66 0 0 0 5.429-13.113h3.018a1.38 1.38 0 0 0 1.37-1.169c.272-1.87.419-3.782.419-5.728a39.89 39.89 0 0 0-.418-5.728zM40 67.586c-15.235 0-27.586-12.35-27.586-27.586 0-15.235 12.35-27.586 27.586-27.586 15.236 0 27.586 12.35 27.586 27.586 0 15.235-12.35 27.586-27.586 27.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M40.138 68.138c-15.464 0-28-12.536-28-28s12.536-28 28-28 28 12.536 28 28-12.536 28-28 28z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 28)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#273648",
    fillRule: "nonzero",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageMembersGear);
export default __webpack_public_path__ + "static/media/manage-members-gear.df0ec8d05b249ff3dd632129fbd4b379.svg";
export { ForwardRef as ReactComponent };